import React from 'react';
import { motion } from 'framer-motion';
import { FaSun, FaMoon } from 'react-icons/fa';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = ({ className = '' }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`relative w-14 h-7 rounded-full transition-colors duration-500 focus:outline-none focus:ring-2 focus:ring-burnt/40 ${className} ${
        isDark ? 'bg-dark-surface border border-burnt/30' : 'bg-cream border border-brown/20'
      }`}
      aria-label={isDark ? 'Ativar modo claro' : 'Ativar modo escuro'}
    >
      <motion.div
        className="absolute top-0.5 w-6 h-6 rounded-full flex items-center justify-center shadow-md"
        animate={{
          x: isDark ? 28 : 4,
          backgroundColor: isDark ? '#C96A2B' : '#5C3D2E',
        }}
        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
      >
        <motion.div
          key={isDark ? 'moon' : 'sun'}
          initial={{ rotate: -90, opacity: 0 }}
          animate={{ rotate: 0, opacity: 1 }}
          exit={{ rotate: 90, opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          {isDark ? (
            <FaMoon className="text-white text-xs" />
          ) : (
            <FaSun className="text-cream text-xs" />
          )}
        </motion.div>
      </motion.div>
    </button>
  );
};

export default ThemeToggle;
